import {configParamsModule} from "../../configParamsModule"
import {IHttpService, IQService, IScope} from "angular";
import {
    LoadingService,
    MessagesModal, NlgSpreadsheetExportService, RemoteExceptionHandler
} from "../../../../bower_components/front-end-web-commons";

import userManagementServer from "../../../userManagementServer";

interface NlgPermissionGroupSelectScope extends IScope {
    onRegisterApi: any
}


class NlgPermissionGroupSelect {
    modifiedTemplate = {}
    filterServiceUrl = "permission-group/presentation-tree"
    paginationApi: any;
    paginationApiDefer: any;
    context: any

    constructor(private loadingService: LoadingService,
                private $http: IHttpService,
                private $scope: NlgPermissionGroupSelectScope,
                private messagesModal: MessagesModal,
                private remoteExceptionHandler: RemoteExceptionHandler,
                private $q: IQService,
                private spreadsheetExportService: NlgSpreadsheetExportService,
                private $translate: any,
                private $filter: any) {
        $scope.onRegisterApi.refreshPermissionGroupPresentationTree = () => this.refreshPresentationTree()
        this.getEmptyPresentationTree();
        this.paginationApiDefer = $q.defer();
        this.context = {
            refilter: () => this.refreshPresentationTree()
        };
    }

    getEmptyPresentationTree() {
        return this.loadingService(
            this.$http.get(userManagementServer.getServiceUrl("permission-group-presentation-tree"))
                .then((response: any) => {
                    this.paginationOptions.records = response.data;
                }));
    }

    createAdminUsers() {
        return this.loadingService(
            this.$http.post(userManagementServer.getServiceUrl("admin-user-creator"), null)
                .then((response: any) => {
                    this.messagesModal("dialog.success", "permissionGroupCreateAdminUsers.success.message")
                        .then(() => this.refreshPresentationTree())
                }).catch(this.remoteExceptionHandler()));
    }


    refreshPresentationTree() {
        this.search(this.modifiedTemplate)
    }


    search(modifiedTemplate: any) {
        this.modifiedTemplate = modifiedTemplate
        this.paginationApi.seekPage(1)
    }


    paginationOptions = {
        records: [],
        pagination: {
            maxPageSize: 10,
            maxPageSizes: [10, 25, 50, 100],
            onPaginate: (firstResult: number, maxResults: number) => {
                this.paginationOptions.records = []
                return this.loadingService(this.$http.post(userManagementServer.getServiceUrl("permission-group-presentation-tree"), this.modifiedTemplate, {
                        params: {
                            firstResult: firstResult,
                            maxResults: maxResults
                        }
                    })
                        .then((response: any) => {
                            return {
                                firstResult: firstResult,
                                maxResults: maxResults,
                                count: response.data.count,
                                result: response.data.result[0]
                            }
                        })
                );
            }
        },
        onRegisterPagination: (api: object) => {
            this.paginationApi = api;
            this.paginationApiDefer.resolve();
        }
    };

    export() {

        let headers = [
            this.$translate.instant("config.params.export.excel.permissionGroup.sourceId"),
            this.$translate.instant("config.params.export.excel.permissionGroup.name"),
            this.$translate.instant("config.params.export.excel.permissionGroup.user"),
            this.$translate.instant("config.params.export.excel.permissionGroup.creationDate"),
            this.$translate.instant("config.params.export.excel.permissionGroup.unities"),
            this.$translate.instant("config.params.export.excel.permissionGroup.responsibleCompany"),
            this.$translate.instant("config.params.export.excel.permissionGroup.inactive")
        ]
        let reportName = this.$translate.instant("config.params.export.excel.permissionGroup.reportName");
        return this.loadingService(
            this.$http.post<any>(userManagementServer.getServiceUrl("permission-group-export"), this.modifiedTemplate, {})
                .then((response) =>
                    this.spreadsheetExportService.exportSpreadsheet(reportName, reportName, headers, this.convertToRows(response.data)))
        );
    }

    convertToRows(content: any): any {
        return content.map(record => {
            let creationTimestamp = this.$filter("date")(record.creationTimestamp, "dd/MM/yyyy H:mm");
            let {code, name, userEmail, unityQuantity, responsibleCompany, inactive} = record;
            return [code, name, userEmail, creationTimestamp, unityQuantity, responsibleCompany, this.getInactiveBundle(inactive)]
        })
    }

    getInactiveBundle(inactive: any) {
        let bundle = inactive ? 'config.params.export.excel.permissionGroup.inactive.yes' : 'config.params.export.excel.permissionGroup.inactive.no'
        return this.$translate.instant(bundle)
    }
}

export const directive = configParamsModule.directive("nlgPermissionGroupSelect", [function () {
    return {
        restrict: "E",
        templateUrl: require("link!./nlgPermissionGroupSelect.html"),
        scope: {
            onRegisterApi: "="
        },
        controllerAs: "ctrl",
        controller: NlgPermissionGroupSelect,
    }
}])


